import { useCallback, useEffect } from 'react'
import { useInstance } from '@10000/react'
import { InputScreen, useBackground, useShell, useStack } from '../layout'
import { Body, Box } from '../widgets'
import { Password, Submit, Text } from '../forms'
import { ForgotPassword, SignUp } from '.'
import { PasswordSetUp } from '../onboarding'
import { authenticate } from './request.js'

export const Authenticate = ({ active }) => {
  const { push, replaceStack } = useStack()
  const { setInstance } = useInstance()

  useBackground().set(mobile => ({ active, background: mobile ? null : 2, fade: true }))
  useShell({ active, mode: 'navigate' })

  const login = useCallback(({ username, password }) => {
    return authenticate(username, password).then(res => {
      const { success, challenge, user } = res
      if(success) {
        setInstance({ id: user.tenantId, region: user.region })
      } else if (challenge) {
        if(challenge.type === 'NEW_PASSWORD_REQUIRED') {
          replaceStack(PasswordSetUp, { props: { challenge: challenge.type, session: challenge.session, username: challenge.username } })
        }
      }
    })
  }, [replaceStack, setInstance])

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    if(query.get('temporaryPassword') && query.get('username')) {
      window.history.pushState({}, '', window.location.pathname)
      // browsers replace + with a space, email addresses can't contain spaces - change spaces back to +
      login({ username: query.get('username').replace(/ /g, '+'), password: query.get('temporaryPassword') })
    }
  }, [login])

  return <InputScreen centered onSubmit={login} title="Welcome">
    <Box fullWidth gap={8} column alignItems="center">
      <Text
        title="Email"
        name="username"
        type="email"
        required
      />
      <Password />
      <Box fullWidth justifyContent="flex-start">
        <a onClick={() => push(ForgotPassword)}>Forgot password? Don&apos;t have one?</a>
      </Box>
    </Box>

    <Box className="fit-button-to-container" fullWidth>
      <Submit fullWidth>Submit</Submit>
    </Box>

    {/*<Body>or</Body>*/}

    {/*<Box gap={8} fullWidth>*/}
    {/*  <IconButton size={24} icon="Google" fullWidth/>*/}
    {/*  <IconButton size={24} icon="Facebook" fullWidth/>*/}
    {/*  <IconButton size={24} icon="Apple" fullWidth/>*/}
    {/*</Box>*/}

    <Box gap={4} alignItems="center">
      <Body>
        New to Shivoo?
      </Body>
      <a onClick={() => push(SignUp)}>Sign-up</a>
    </Box>
  </InputScreen>
}
